import { NA, NBSP } from './constants';
import { hasDecimal, currencySubfix, getAllExceptLastFromArray, roundNumberAndReturnAsString } from './numbers-utils';

const intParser = (value: string | number) => parseInt(`${value}`, 10);

export const isNumber = (value: unknown) => !Number.isNaN(intParser(value as string));

export const spaceEveryThirdNumber = (price: string): string => price.replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0');

export const formatPrice = (value: string | number, or = NA): string => {
    const isValueNumber = isNumber(value);
    if (!isValueNumber) {
        return or;
    }

    const valueAsString = roundNumberAndReturnAsString(value);

    const isValueDecimal = hasDecimal(valueAsString);
    const numberAsArray = valueAsString.split(/[.,]/g);

    if (isValueDecimal) {
        return `${spaceEveryThirdNumber(getAllExceptLastFromArray(numberAsArray))}${currencySubfix}`;
    }

    const numberWithPeriodsAsSpace = valueAsString.replace('.', NBSP);
    return `${spaceEveryThirdNumber(numberWithPeriodsAsSpace)}${currencySubfix}`;
};

export const formatMobilnummer = (mobilnummer: string): string => {
    const mobilnummerWithoutSpaces = mobilnummer.replace(/\s/g, '');

    return mobilnummerWithoutSpaces.length === 8
        ? `${mobilnummerWithoutSpaces.substring(0, 2)}${NBSP}${mobilnummerWithoutSpaces.substring(
              2,
              4,
          )}${NBSP}${mobilnummerWithoutSpaces.substring(4, 6)}${NBSP}${mobilnummerWithoutSpaces.substring(6)}`
        : mobilnummerWithoutSpaces;
};

export const format8DigitPhoneNumber = (phoneNumber: string): string => {
    if (phoneNumber.length !== 8) return phoneNumber;
    const isMobileNumber = new RegExp(/^[49]/).test(phoneNumber);
    return isMobileNumber
        ? phoneNumber.replace(/(\d{3})(\d{2})(\d{3})/, `$1${NBSP}$2${NBSP}$3`)
        : phoneNumber.replace(/(\d{2})(\d{2})(\d{2})(\d{2})/, `$1${NBSP}$2${NBSP}$3${NBSP}$4`);
};
